import {IsTestBookedConfiguration, IsTestBookedForm} from '../../../../fields/testing/types'
import {CreateFormInput} from '../types'

export const buildIsTestBookedForm = ({
  order
}: CreateFormInput<IsTestBookedConfiguration>): IsTestBookedForm => {
  return {
    isTestBooked: order.isTestBooked
  }
}
